module.exports = __webpack_public_path__ + "img/moohb.6c448481.png";